import { useCubeStore } from "@/stores/useCubeStore";
import { useSettingsStore } from "@/stores/useSettingsStore";

export function usePlans() {
  /**
   * This terrible business logic is being reused as-is from app-v2.
   * TODO Clean this up.
   */

  const settingsStore = useSettingsStore()
  const cubeStore = useCubeStore()

  function getPlanState() {
    return {
      settings: { contractData: settingsStore.contractData },
      cube: { planName: cubeStore.planName },
    }
  }

  // In Consumers.vue there is a function that is also called isBusinessPlan.
  // They use different values for plan names and also check a different property:
  // plans.con vs plans.gen.
  // TODO APP-574 Clean this up.
  function isBusinessPlan() {
    const state = getPlanState();

    switch (state.settings.contractData.plans.con?.name) {
      case 'eFRIENDS_CONNECT':
      case 'eFRIENDS_CONNECT_LieferungvomKunden':
      case 'eFRIENDS_SOFORT':
      case 'eFRIENDS_SOFORT_LieferungvomKunden':
      case 'CLEEN Energy CONNECT':
      case 'CLEEN Energy CONNECT_LieferungvomKunden':
      case 'eFRIENDS_Osteraktion2019':
      case 'eFRIENDS_CONNECT_derbessereTarif':
      case 'eFRIENDS_derbessereTarif_BUSINESS':
      case 'der_bessere_FLOAT':
      case 'der_bessere_FLOAT_LieferungVomKunden':
        return false
      default:
        return true
    }
  }

  const getPlan = () => {
    const state = getPlanState();
    return state.settings.contractData.plans.con || state.settings.contractData.plans.gen
  }

  const getConsumptionPlan = () => {
    const state = getPlanState();
    return state.settings.contractData.plans.con
  }

  const getGenerationPlan = () => {
    const state = getPlanState();
    return state.settings?.contractData?.plans?.gen
  }

  const getGenerationPlanName = () => {
    const planNameFull: string = getGenerationPlan()?.name ?? ''

    const indexOfSuffix = planNameFull.toLowerCase().indexOf('_lieferungvomkunden')
    const baseName =
      indexOfSuffix === -1 //
        ? planNameFull
        : planNameFull.substring(0, indexOfSuffix)
    const planName = baseName.replaceAll('_', ' ')

    return planName
  }

  function isFlexPlan() {
    const state = getPlanState();
    const plan = getPlan()

    return plan
      ? (plan?.specs?.FFF as string)?.toLowerCase() == 'flex'
      : (state.cube?.planName?.toUpperCase()?.indexOf('FLEX') ?? 0) > -1
  }

  function isFloatPlan() {
    const state = getPlanState();
    const plan = getPlan()

    return plan
      ? (plan?.specs?.FFF as string)?.toLowerCase() == 'float'
      : (state.cube?.planName?.toUpperCase()?.indexOf('FLOAT') ?? 0) > -1
  }

  function isFixPlan() {
    const plan = getPlan()

    return plan
      ? (plan?.specs?.FFF as string)?.toLowerCase() == 'fix'
      : !isFlexPlan() && isFloatPlan()
  }

  const hasGenerationPlanStandardPrice = () => {
    return (
      getGenerationPlan()?.standardPrice != null &&
      (getGenerationPlan()?.vatPrice ?? 0) != 0
    )
  }

  return {
    isBusinessPlan,
    isFlexPlan,
    isFloatPlan,
    isFixPlan,
    getPlan,
    getGenerationPlan,
    getGenerationPlanName,
    getConsumptionPlan,
    hasGenerationPlanStandardPrice
  }
}
